import { useTranslation } from 'react-i18next'
import { PrometheusAlert, RuuviTag, RuuviTagCondition } from '../types'
import RuuviTagStats from './RuuviTagStats'
import { AlertRuleName } from '../enums'
import { translateAlertRuleName } from '../utils/alert'

interface RuuviTagTemperatureStatsProps {
  ruuviTag: RuuviTag
  ruuviTagCondition: RuuviTagCondition | null
  alerts?: PrometheusAlert[]
  loading?: boolean
}

export default function RuuviTagTemperatureStats({
  ruuviTag,
  ruuviTagCondition,
  alerts = [],
  loading = false
}: RuuviTagTemperatureStatsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The temperature alerts.
   */
  const temperatureAlerts = alerts.filter(
    (alert) =>
      alert.labels.alertname === AlertRuleName.LOW_TEMPERATURE ||
      alert.labels.alertname === AlertRuleName.HIGH_TEMPERATURE
  )

  /**
   * Indicates if there is an active temperature alert.
   */
  const isTemperatureAlerting = temperatureAlerts.length > 0

  /**
   * The latest temperature alert.
   */
  const latestTemperatureAlert = temperatureAlerts.length > 0 ? temperatureAlerts[0] : undefined

  return (
    <RuuviTagStats
      ruuviTag={ruuviTag}
      title={t('temperature')}
      value={ruuviTagCondition?.temperatureAvg}
      unit="°C"
      date={ruuviTagCondition?.time}
      loading={loading}
      alerting={isTemperatureAlerting}
      alertText={
        latestTemperatureAlert && translateAlertRuleName(latestTemperatureAlert.labels.alertname)
      }
    />
  )
}
